import { inject as i, openBlock as p, createBlock as n, resolveDynamicComponent as s, normalizeProps as m, guardReactiveProps as a, createSlots as c, renderList as l, withCtx as d, renderSlot as f } from "vue";
/* empty css                    */
import g from "./design-system.es128.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import u from "./design-system.es56.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
const _ = {
  name: "DsTooltipTrigger",
  components: {
    DsFilledButton: u
  },
  props: {
    as: {
      type: [String, Object],
      default: "DsFilledButton"
    }
  },
  setup() {
    const { triggerProps: r } = i("dsTooltip");
    return {
      triggerProps: r
    };
  }
};
function T(r, B, o, e, D, P) {
  return p(), n(s(o.as), m(a(e.triggerProps.attrs)), c({ _: 2 }, [
    l(r.$slots, ($, t) => ({
      name: t,
      fn: d(() => [
        f(r.$slots, t)
      ])
    }))
  ]), 1040);
}
const L = /* @__PURE__ */ g(_, [["render", T]]);
export {
  L as default
};
//# sourceMappingURL=design-system.es114.js.map
